import { useRef } from 'react';

export function useScrollRestoration() {
  const scrollYRef = useRef(0);

  const capture = (element) => {
    if (element && element.getBoundingClientRect) {
      const rect = element.getBoundingClientRect();
      scrollYRef.current = window.scrollY + rect.top - 16;
      return;
    }
    scrollYRef.current = window.scrollY;
  };

  const restore = () => {
    const target = scrollYRef.current || 0;
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: target, behavior: 'auto' });
    });
  };

  return { capture, restore };
}
